import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SelectOption } from '@app/interfaces/sys/dict';
import { FileService } from '@services/lm/file.service';

@Component({
  selector: 'app-avatar-group',
  templateUrl: './avatar-group.component.html',
  styleUrl: './avatar-group.component.less'
})
export class AvatarGroupComponent implements OnChanges {
  @Input() list!: SelectOption[];
  @Input() maxVisibleAvatars = 9999999; // Max avatars to display
  @Input() size = 24;
  colorArr: {
    [key: string]: string
} = {
    A: '#125082',
    B: '#3a0e72',
    C: '#640646',
    D: '#095417',
    E: '#544609',
    F: '#366d1b',
    G: '#BD5FFC',
    H: '#FC5F77',
    I: '#23f7ee',
    J: '#0A6D3A',
    K: '#6B2EAD',
    L: '#DA2F15',
    M: '#80aa65',
    N: '#AAFF56',
    O: '#6c4d63',
    P: '#FFDEAD',
    Q: '#c7ed98',
    R: '#8AC153',
    S: '#214c9c',
    T: '#8893b8',
    U: '#216ae3',
    V: '#e9d2ca',
    W: '#bbc730',
    X: '#473C9D',
    Y: '#e0aff7',
    Z: '#007B52',
};

constructor(private fileService: FileService) {
}
  ngOnChanges(changes: SimpleChanges): void {
    const { list } = changes;
    // console.log('changes', changes);
  }

  isMemberActive(member: SelectOption): boolean {
    return member.enable ?? true;
  }

  getBackgroundColor(name: string): string {
    const firstCode = name.slice(0, 1).toUpperCase();
    const charCode = this.colorArr[firstCode];
    return charCode;
  }

  getAvatarImage(avatar: string): string {
    if (!avatar || avatar.startsWith('http')) {
        return avatar || '';
    }
    return this.fileService.getPath(avatar);
  }
}
